import { Component, HostBinding, ViewEncapsulation } from "@angular/core";

@Component({
  selector: "app-success-container",
  imports: [],
  templateUrl: "./success-container.component.html",
  styleUrls: ["./success-container.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SuccessContainerComponent {
  @HostBinding("class.successContainer") containerClass = true; // To limit styles to the successContainer class
}
